import { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Typography,
  Box,
  Tooltip,
  IconButton,
  InputBase,
  Button,
  TextField,
  DialogContent,
  DialogActions,
  Dialog,
} from "@mui/material";
import { DataGrid, faIR } from "@mui/x-data-grid";
import { UseUserswallet } from "./UseUserswallet";
import { UseMyPC } from "../../hooks/UseMyPC";
import CustomPagination from "../../components/CustomPagination";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { deCapitalizeFirstLetter, toMoney } from "../../util/Utils";
import { rsProgress, rsActiveMenu, rsGotoLast } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { useNavigate, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import UserWalletDetails from "./UserWalletDetails";
import { useSnackbar } from "notistack";

export default function Userswallet() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const location = useLocation();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { getWalletList, getWalletByMobile } = UseUserswallet();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC();

  const [search, setSearch] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [searchState, setSearchState] = useState(
    location.state && location.state.search ? location.state.search : ""
  );
  const [walletRes, setWalletRes] = useState();
  const [openAdd, setOpenAdd] = useState(false);
  const [mobileState, setMobileState] = useState("");

  const [openDetail, setOpenDetail] = useState({
    show: false,
    mobile: undefined,
  });

  function handleSearch(value) {
    setScrollTo(undefined);
    location.state = null;
    setSearch(value);
  }

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }
    setProgress(true);
    getWalletList(
      myPc,
      search,
      (Wallets) => {
        setWalletRes(Wallets);
      },
      true
    );
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  const newFunc = () => {
    setOpenAdd(true);
  };

  const columns = [
    {
      field: "id",
      width: 80,
      align: "center",
      headerName: "id",
      headerAlign: "center",
      hide: true,
    },
    {
      field: "rowNO",
      width: 80,
      align: "center",
      headerName: "ردیف",
      headerAlign: "center",
      sortable: false,
    },
    {
      field: "mobile",
      headerName: "موبایل",
      width: 130,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "fullName",
      headerName: "نام",
      width: 170,
      align: "center",
      sortable: false,
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ whiteSpace: "normal" }}>
            {cellValues.row.fullName}
          </Typography>
        );
      },
    },
    {
      field: "cost",
      headerName: "مبلغ کیف پول",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2">
            {cellValues.row.cost ? toMoney(cellValues.row.cost) : 0}
          </Typography>
        );
      },
    },
    {
      field: "shamsiLastUpdate",
      headerName: "به‌روزرسانی",
      width: 120,
      align: "center",
      headerAlign: "center",
      renderCell: (cellValues) => {
        return (
          <Typography variant="body2" sx={{ direction: "rtl" }}>
            {cellValues.row.shamsiLastUpdate}
          </Typography>
        );
      },
    },
    {
      field: "جزئیات",
      sortable: false,
      width: 90,
      headerAlign: "center",
      align: "center",
      headerName: "جزئیات",
      renderCell: (cellValues) => {
        return (
          <Button
            color="secondary"
            onClick={() => {
              setOpenDetail({ show: true, mobile: cellValues.row.mobile });
            }}
            variant="contained"
          >
            جزئیات
          </Button>
        );
      },
    },
    {
      field: "search",
      width: 250,
      sortable: false,
      renderHeader: (cellValues) => {
        return (
          <Box
            sx={{ border: "1px solid #d3d3d3", borderRadius: 1 }}
            width="auto"
            display="flex"
            justifyContent="flex-start"
          >
            <InputBase
              sx={{ ml: 2, flex: 1 }}
              placeholder="جستجو"
              value={searchState}
              inputProps={{ "aria-label": "search" }}
              onChange={(evt) => {
                if (evt.target.value == "") {
                  handleSearch("");
                }
                setSearchState(evt.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleSearch(searchState);
                }
              }}
            />
          </Box>
        );
      },
    },
  ];

  return (
    <Detail
      breadChilds={{
        title: "سفارشات",
        childs: [
          {
            name: msActiveMenu.pageTitle,
            url: "/userswallet",
          },
        ],
      }}
    >
      {walletRes ? (
        <DataGrid
          className="ltr-grid"
          localeText={faIR.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          pageSize={walletRes.pageCondition.pageCount}
          rows={walletRes.wallets}
          paginationMode="server"
          page={walletRes.pageCondition.page - 1}
          onPageChange={(page) => {
            updatePage(page + 1);
          }}
          rowCount={walletRes.pageCondition.totalItemCount}
          enableRangeSelection={true}
          disableColumnMenu
          hideFooterSelectedRowCount
          components={{
            Pagination: CustomPagination,
          }}
          componentsProps={{
            pagination: {
              newFunc: newFunc,
              scrollTo: myPc.scrollTo,
              isLtr: true,
              // nofab: true,
              rowCount:
                walletRes && walletRes.pageCondition.totalItemCount
                  ? walletRes.pageCondition.totalItemCount
                  : "",
            },
          }}
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: deCapitalizeFirstLetter(myPc.sortColumn),
                  sort: deCapitalizeFirstLetter(myPc.sortOrder),
                },
              ],
            },
            pagination: {
              page: myPc.page,
            },
          }}
          onSortModelChange={(model) => {
            updateSort(model[0].field, model[0].sort == "asc" ? "asc" : "desc");
          }}
          sortingOrder={["desc", "asc"]}
          sortingMode="server"
        />
      ) : (
        <ProgressCom></ProgressCom>
      )}
      {openDetail.show && (
        <UserWalletDetails
          openDetail={openDetail}
          setOpenDetail={setOpenDetail}
          callback={() =>
            getWalletList(
              myPc,
              search,
              (Wallets) => {
                setWalletRes(Wallets);
              },
              false
            )
          }
        />
      )}
      <Dialog
        open={openAdd}
        maxWidth="xs"
        fullWidth
        onClose={() => setOpenAdd(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <TextField
            sx={{ mt: 1 }}
            size="small"
            autoFocus
            id="outlined-basic"
            value={mobileState ? mobileState : ""}
            label="شماره همراه را وارد کنید "
            fullWidth
            variant="outlined"
            onChange={(event) => setMobileState(event.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                getWalletByMobile(mobileState, (callback) => {
                  setOpenAdd(false);
                  setMobileState("");
                  setOpenDetail({
                    show: true,
                    mobile: mobileState,
                  });
                });
              }
            }}
          />
          <Box sx={{ mt: 2, display: "flex", justifyContent: "center" }}>
            <Button
              sx={{ mr: 2 }}
              size="small"
              variant="contained"
              onClick={() => {
                if (!mobileState || mobileState.length < 11) {
                  enqueueSnackbar("لطفا شماره را کامل وارد کنید", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
                getWalletByMobile(mobileState, (callback) => {
                  setOpenAdd(false);
                  setMobileState("");
                  setOpenDetail({
                    show: true,
                    mobile: mobileState,
                  });
                });
              }}
            >
              اضافه کردن
            </Button>
            <Button
              size="small"
              variant="outlined"
              color="secondary"
              onClick={() => {
                setMobileState("");
                setOpenAdd(false);
              }}
            >
              انصراف
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Detail>
  );
}
